<template>
  <v-container fluid class="unicode-escapes">
    <v-row class="flex-grow-0">
      <v-btn text
             x-small
             color="primary"
             exact
             :to="{name: 'settings'}">
        &lt;&lt; {{ $t('app_drawer.settings') }}
      </v-btn>
    </v-row>
    <v-row class="flex-grow-0">
      <h3>{{ $t('unicode_escape.title') }}</h3>
      <v-btn color="primary"
             class="ml-4"
             small
             @click="exportUnicodeEscapes">
        Export
      </v-btn>
      <v-btn color="primary"
             class="ml-4"
             small
             @click="importUnicodeEscapes">
        Import
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-1">
      <UnicodeEscapeList full-height
                         :refresh-trigger.sync="refreshTrigger"></UnicodeEscapeList>
    </v-row>
  </v-container>
</template>

<script>
import ImportUnicodeEscapeDialog from "@/components/unicodeEscape/ImportUnicodeEscapeDialog";
import {ref} from "@vue/composition-api/dist/vue-composition-api";
import {ACTION_TYPES} from "@/store/types";
import UnicodeEscapeList from "@/components/unicodeEscape/UnicodeEscapeList";

export default {
  name: 'UnicodeEscapes',
  components: {UnicodeEscapeList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const exportUnicodeEscapes = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/unicode_escape/export/',
        params: {},
        opt: {extra: {responseType: 'arraybuffer'}},
      });

      let disposition = response.headers.get('Content-Disposition');
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      let filename = matches[1].replace(/['"]/g, '');

      let blob = new Blob([response.data], {type: response.headers.get('content-type')});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURIComponent(filename)
      link.click();
    };

    const importUnicodeEscapes = async function () {
      await root.$dialog.showAndWait(ImportUnicodeEscapeDialog, {
        showClose: false,
        persistent: true,
      });
      refresh();
    };

    return {
      refreshTrigger,
      refresh,
      exportUnicodeEscapes,
      importUnicodeEscapes,
    }
  },
}
</script>

<style lang="less">
.unicode-escapes {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
